import { URL_API } from '@/config/api';
import axiosAuth from '@/utils/axios';

export async function createBuyChips(body) {
  const url = `${URL_API}/auto-attendance/sendApp`;
  let response = await axiosAuth.post(url, body);
  return response.data;
}